import IStepReassignmentDto from '@Shared.Angular/@types/core/contracts/queryModel/delegation/stepReassignmentDto';
import { Guid } from '@Shared.Angular/@types/guid';
import { ReassignType } from '@Shared.Angular/flowingly.services/flowingly.constants';
import { ActorType } from '@Client/interfaces/runner.actor-type.enum';

export interface IReassignmentFormValues {
  actorType: ActorType;
  userIdToReassignTo: Guid | null | undefined;
  teamIdToReassignTo: Guid | null | undefined;
  approverBeingReplacedId: Guid | null | undefined;
  reason: string;
  isParallelApproverStep: boolean;
  hasXssValidationError: boolean;
}

export interface IReassignmentRequestValues {
  reassignType: ReassignType;
  actorType: ActorType;
  userIdToReassignTo: Guid | null | undefined;
  teamIdToReassignTo: Guid | null | undefined;
  reassignedFromActorId: Guid | null | undefined;
  approverBeingReplacedId: Guid | null | undefined;
  currentTaskId: Guid | undefined;
  stepId: Guid | undefined;
  reason: string;
  flowId: Guid;
}

export const canReassignToTeam = (
  reassignType: ReassignType,
  isParallelApproverStep: boolean,
  isSequentialApproverStep: boolean
): boolean =>
  reassignType === ReassignType.Step &&
  !isParallelApproverStep &&
  !isSequentialApproverStep;

export const getUniqueApprovers = <T extends { ApproverUserId: Guid }>(
  approvers: T[]
): T[] =>
  approvers.filter(
    (approver, index, allApprovers) =>
      index ===
      allApprovers.findIndex(
        (candidate) => candidate.ApproverUserId === approver.ApproverUserId
      )
  );

export const isReassignmentFormValid = ({
  actorType,
  userIdToReassignTo,
  teamIdToReassignTo,
  approverBeingReplacedId,
  reason,
  isParallelApproverStep,
  hasXssValidationError
}: IReassignmentFormValues): boolean =>
  reason.trim() !== '' &&
  (actorType === ActorType.User
    ? !!userIdToReassignTo
    : !!teamIdToReassignTo) &&
  (!isParallelApproverStep || !!approverBeingReplacedId) &&
  !hasXssValidationError;

export const buildReassignmentRequest = ({
  reassignType,
  actorType,
  userIdToReassignTo,
  teamIdToReassignTo,
  reassignedFromActorId,
  approverBeingReplacedId,
  currentTaskId,
  stepId,
  reason,
  flowId
}: IReassignmentRequestValues): IStepReassignmentDto => ({
  reassignType,
  reassignedToUserId: actorType === ActorType.User ? userIdToReassignTo : null,
  reassignedToGroupId: actorType === ActorType.Team ? teamIdToReassignTo : null,
  reassignedFromUserOrGroupId: approverBeingReplacedId || reassignedFromActorId,
  stepTaskId:
    reassignType === ReassignType.StepTask ? currentTaskId : undefined,
  reason,
  stepId,
  flowId
});
